import React from 'react';
import {Grid, Checkbox, Segment, Button, Label, Icon} from 'semantic-ui-react';

export default (props) => {
    return <Grid>
        <Grid.Row>
            <Grid.Column>
                <Segment basic clearing style={{padding: 0}} textAlign="left">
                    <Segment basic style={{padding: 0}}>
                        <Button style={{borderRadius: 0}} type="back" negative onClick={() => window.open(props.lang.form_container.task_terms)}>
                            <Icon name="list alternate outline"/>
                            {props.lang.form_container.task_rules_label}
                        </Button>
                    </Segment>
                    <Segment basic style={{padding: 0}}>
                        <Label style={{paddingLeft: 0, background: "transparent"}}>
                            <Checkbox checked={props.isChecked} onChange={props.handleCheck} label={props.lang.form_container.task_rules_agree} />
                        </Label>
                    </Segment>
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>
}


// WEBPACK FOOTER //
// ./src/components/agreeBox/AgreeBoxContainer.jsx